// @flow

/**
 * Do not use this slice. This is an implementation detail of the current router
 * and may be eliminated in the future. It does not support important functionality
 * such as integration with the browser's History API.
 */

import type { ExtractReturn } from '@ta/common.types';
import type { Action as AllActions } from './state';

// eslint-disable-next-line flowtype/require-exact-type
export type State = {
  page: string,
  [string]: any,
};

export const NAVIGATE = 'NAVIGATE';
export const navigate = (to: State, builtUrl?: string) => ({
  type: NAVIGATE,
  to,
  builtUrl,
});

export type Action = ExtractReturn<typeof navigate>;

const emptyState = () => ({ page: 'Home' });

export default (state: State = emptyState(), action: AllActions): State => {
  switch (action.type) {
    case NAVIGATE:
      return { ...action.to };
    default:
      return state;
  }
};
